import { render } from "./ClientSpaceSuccess.vue?vue&type=template&id=03498e4e&scoped=true"
import script from "./ClientSpaceSuccess.vue?vue&type=script&lang=js"
export * from "./ClientSpaceSuccess.vue?vue&type=script&lang=js"

import "./custom-clientSpace.scss?vue&type=style&index=0&id=03498e4e&lang=scss&scoped=true"
import "./custom-clientSpaceSuccess.scss?vue&type=style&index=1&id=03498e4e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03498e4e"]])

export default __exports__